import React, { PropTypes } from 'react';
import { fullDateFormat } from '../../utils';

const renderItem = (item, index) => {
  const getMarkup = () => item.description;
  return (
    <a
      key={index}
      className="news"
      href={item.link}
      target="_blank"
      rel="noopener noreferrer"
      title={item.title}
    >
      <article>
        <time dateTime="2016-08-24">{fullDateFormat(item.fullDate)}</time>
        <div className="articles-details">
          <h1>{item.title}</h1>
          <p dangerouslySetInnerHTML={{ __html: getMarkup() }} />
        </div>
      </article>
    </a>
  );
};

const SimpleList = ({ items = [] }) => (
  <div className="col-sm-12 simple-list-container">
    <div>
      {items.map(renderItem)}
    </div>
  </div>
);

SimpleList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      title: PropTypes.string,
      date: PropTypes.string,
      description: PropTypes.string,
      thumbnail: PropTypes.string,
      fullDate: PropTypes.string
    })
  )
};

export default SimpleList;



// WEBPACK FOOTER //
// ./src/pages/press/components/SimpleList/SimpleList.js